import Container from '@v2/shared/components/Container';
import backIssues from './images/backissues.png';

export default function BackIssuesPanel() {
  return (
    <div className="grid justify-center bg-zinio-purple-100">
      <Container className="grid grid-cols-1 lg:grid-cols-2 py-16 sm:py-20 md:py-20 lg:py-20 xl:py-28">
        <span className="flex justify-center items-start flex-col lg:pr-20 xl:pr-16">
          <h2 className="text-zinio-purple-900 text-4xl md:text-4xl lg:text-3xl xl:text-5xl mb-5 lg:mb-10 font-bold max-w-xl">
            Access back issues you might&rsquo;ve missed
          </h2>
          <p className="text-zinio-purple-900 text-md md:text-md lg:text-lg xl:text-xl font-semibold mb-8 lg:mb-0">
            With ZINIO Unlimited, you have access to back issues, allowing you to go back in time and read your
            favorites before you knew they were your favorites.
          </p>
        </span>
        <span className="w-full h-full flex items-center justify-center pt-0 sm:pt-4 md:pt-10 lg:pt-0">
          <img src={backIssues} width={1728} height={628} alt="Back issues timeline" className="w-full h-auto" />
        </span>
      </Container>
    </div>
  );
}
